import { render, staticRenderFns } from "./MonthPelletizingProductInfoList.vue?vue&type=template&id=81724448&"
import script from "./MonthPelletizingProductInfoList.vue?vue&type=script&lang=js&"
export * from "./MonthPelletizingProductInfoList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports